/**
 * Created by JAVIER on 10/29/2019.
 */

import React from 'react';
import { Modal, Carousel } from 'antd';
import './modalCarousel.css'

function pauseVideo()  {
    let mediaElement = document.getElementsByTagName('video');
    for(let i = 0; i < mediaElement.length; i++){
        mediaElement[i].pause();
    }
}

class ModalCarousel extends React.Component{

    getImageURL = (videoId)=>{
        if (this.props.shared){
            return "/api/v1/share/videos/image/medium/"+videoId+"?token="+this.props.token
        }
        else {
           return '/api/v1/videos/image/medium/' + videoId
        }
    }

    getMP4URL =(videoId)=>{
        if (this.props.shared){
            return "/api/v1/share/videos/mp4/"+videoId+"?token="+this.props.token
        }
        else {
            return '/api/v1/videos/mp4/' + videoId
        }
    }


    renderVideos = (videos)=>{
        return videos.map( v => {
            return (
                <div>
                    <video className="unsetScaleVideo" poster={this.getImageURL(v._id)} preload="none" width="855" height="500" controls>
                        <source src={this.getMP4URL(v._id)} type="video/mp4"/>
                    </video>
                </div>
            )
        })
    }

    render(){

        return (
            <Modal
                id="videos"
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                footer={null}
                centered
                width={930}
                bodyStyle={{
                    background: 'linear-gradient(to left, black, 10%, gray, 90%, black)'
                }}
            >
                <div style={{margin: '15px'}}>
                    <Carousel
                        beforeChange={(oldIndex, newIndex) => {
                            pauseVideo();
                            console.log('carousel:', oldIndex, newIndex);
                         }}
                        dots={false}
                        arrows={true}
                        infinite={false}
                        initialSlide={this.props.initialSlide}
                        key={this.props.initialSlide}>
                        {this.renderVideos(this.props.videos)}
                    </Carousel>
                </div>
            </Modal>
        )
    }
}

export default ModalCarousel;